export var MessageType;
(function (MessageType) {
    MessageType[MessageType["Status"] = 1] = "Status";
    MessageType[MessageType["Chat"] = 2] = "Chat";
    MessageType[MessageType["Automated"] = 3] = "Automated";
})(MessageType || (MessageType = {}));
export default MessageType;
//# sourceMappingURL=message-type.js.map